import { Entity, Field } from '@adornis/baseql/decorators.js';
import { Base } from '@adornis/buildify/db/Base.js';
import { BaseText } from '@adornis/buildify/db/extensions/text/BaseText.js';

@Entity()
export class BaseSlider extends Base {
  static override _class = 'BaseSlider';

  @Field(type => [BaseText]) texts?: BaseText[];
  @Field(type => Boolean) slideAutomatic?: boolean;
}
